import { CloseSquare } from "iconsax-react";
import Spinner from "../../spinners/Spinner";

export default function CancelOrderConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[#11111180] flex items-center justify-center p-4">
      <div className="bg-white rounded-md w-full max-w-[420px] shadow-xl overflow-hidden">
        <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between gap-4">
          <div>
            <h2 className="text-[15px] font-medium select-none">
              Cancel order?
            </h2>
            <p className="text-xs opacity-80 mt-1">
              Are you sure you want to cancel this order?
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="h-fit disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <CloseSquare variant="Bold" />
          </button>
        </div>
        <div className="flex justify-end gap-3 py-5 px-5">
          <button
            type="button"
            className="text-xs w-[90px] h-[40px] flex items-center justify-center bg-primary-light rounded-md py-2 px-2 hover:opacity-80 duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={onClose}
            disabled={loading}
          >
            No
          </button>
          <button
            type="button"
            className="text-xs w-[90px] h-[40px] flex items-center justify-center bg-[tomato] text-white rounded-md py-2 px-2 hover:opacity-80 duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <Spinner color="white" /> : "Yes"}
          </button>
        </div>
      </div>
    </div>
  );
}
